module.exports = __webpack_public_path__ + "img/3.69cfa497.svg";